<template>
  <div>
    <template v-if="!layout.loading">
      <!-- 没有找到用户信息 -->
      <div class="user-info-not-found" v-if="layout.notFoundUser">
        <img src="../../../assets/imgs/work-wx/customer/none-info.png" />
        <div class="none-info-text">未检测到该用户信息</div>
      </div>

      <!-- 有用户信息 -->
      <div class="customer-container" v-else>
        <user-infos :user-info="userInfo"></user-infos>
        <order-list
          v-model="formInfo.searchText"
          :order-list="orderList"
          @getOrderList="refreshOrderList"
        >
        </order-list>
      </div>
    </template>

    <div class="loading" v-else>
      <van-loading color="#1989fa" />
    </div>
  </div>
</template>

<script>
import utils from '@/services/tools';
import userInfos from './components/user-infos.vue';
import orderList from './components/order-list/order-list.vue';
import workWxCommonService from '../services/work-wx-common-service.js';
import customerService from './services/customer-service.js';

export default {
  components: {
    userInfos,
    orderList,
  },
  data() {
    return {
      layout: {
        loading: false,
        notFoundUser: false,
      },
      formInfo: {
        searchText: undefined,
      },
      userInfo: {},
      orderList: [],
    };
  },
  mounted() {
    this.layout.loading = true;
    this.init().finally(() => {
      this.layout.loading = false;
    });
  },
  methods: {
    async init() {
      try {
        await workWxCommonService.commonLogin();
        await this.getUserInfo();
        await this.getOrderList();
      } catch (e) {
        utils.showError(e);
      }
    },
    // 获取用户信息
    async getUserInfo() {
      try {
        const res = await customerService.userInfoQuery();
        this.userInfo = res;
      } catch (e) {
        if (e.ret === -2) {
          this.layout.notFoundUser = true;
          // 跳转到账号绑定
          this.$router.replace({
            name: 'bindCustomerAccount',
            query: { isJump: true },
          });
          throw e;
        } else {
          const err = { msg: '获取同业信息失败' };
          throw err;
        }
      }
    },
    // 同业订单列表查询
    async getOrderList() {
      try {
        const res = await customerService.userOrderBriefQuery(
          this.formInfo.searchText,
        );
        this.orderList = res.page_data;
      } catch (e) {
        const err = { msg: '获取同业订单列表失败' };
        throw err;
      }
    },
    async refreshOrderList() {
      this.layout.loading = true;
      this.getOrderList().finally(() => {
        this.layout.loading = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.customer-container {
  > div {
    margin-top: 12px;
    &:first-child {
      margin-top: 0;
    }
  }
}
.loading {
  width: 100%;
  padding-top: 100px;
  background: #f5f6f7;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #918f8f;
  text-align: center;
}
</style>
